export default __webpack_public_path__ + "images/0da29b16c69cb01918b840b7f0b667f0-auto.jpg";